import appendQuery from 'append-query';
import { refreshToken } from './RefreshToken';
import {RequestGet, RequestPost} from "../apiClient/api/RequestService";
import {UnreceivedTransStatus} from "../utils/unreceived";

const TOKEN_INVALID_CODE = 3021;

export const UnreceivedAction = {
  LOAD_UNRECEIVED_TRANS: 'LOAD_UNRECEIVED_TRANS',
  LOAD_UNRECEIVED_TRANS_SUCCESS: 'LOAD_UNRECEIVED_TRANS_SUCCESS',
  LOAD_UNRECEIVED_TRANS_FAIL: 'LOAD_UNRECEIVED_TRANS_FAIL',
  RESET_UNRECEIVED_TRANS: 'RESET_UNRECEIVED_TRANS',
};

function loadStart() {
  return { type: UnreceivedAction.LOAD_UNRECEIVED_TRANS };
}

function loadSuccess(unreceviedTrans, totalTrans, totalAmount) {
  return { type: UnreceivedAction.LOAD_UNRECEIVED_TRANS_SUCCESS, transactions: unreceviedTrans, totalTrans, totalAmount };
}

function loadFailed() {
  return { type: UnreceivedAction.LOAD_UNRECEIVED_TRANS_FAIL };
}

function resetUnreceivedTransAction() {
  return { type: UnreceivedAction.RESET_UNRECEIVED_TRANS };
}

export function resetUnreceivedTrans() {
  return async (dispatch) => {
    dispatch(resetUnreceivedTransAction());
  };
}

export function loadUnreceivedTrans(app_id, branch_id, store_id, cashier_id, dataToken) {
  return async (dispatch) => {
    dispatch(loadStart());

    const res = await RequestGet(appendQuery('/v1/transactions/unreceived', { app_id, branch_id, store_id, cashier_id }), { token: dataToken.access_token });
    if (res?.return_code === 1) {
      let trans = res.data ? (res.data.transaction ?? []) : [];
      trans = trans.filter((trx) => trx.resubmit_state !== UnreceivedTransStatus.UNSPECIFIED && trx.resubmit_state !== UnreceivedTransStatus.FAILED);

      const totalTrans = Array.isArray(trans) ? trans.length : 0;
      const totalAmount = trans.reduce((totalAmount, tran) => totalAmount += Number.isInteger(tran.amount) ? Number(tran.amount) : 0, 0);
      dispatch(loadSuccess(trans, totalTrans, totalAmount));
    } else if (res.sub_return_code === TOKEN_INVALID_CODE) {
      dispatch(refreshToken(dataToken));
    } else {
      dispatch(loadFailed());
    }
  };
}

export async function resubmitTransaction(transaction, dataToken) {
  const res = await RequestPost('/v1/transactions/confirm', { transaction_reference: transaction.napas_reference_no }, { token: dataToken.access_token });
  if (res?.return_code === 1) {
    return true;
  } else if (res.sub_return_code === TOKEN_INVALID_CODE) {
    return false;
  }
}
